$height-panel: 95vh;
$height-panel-header: 5vh;

.slide-backdrop {
  &.visible {
    display: none;
    position: fixed;
    display: block;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    background-color: var(--backdrop-background-color-primary, palette('backdrop-background', 'primary'));
    z-index: $zindex-slider-container - 10;
    animation: backdropFadeIn 0.5s ease-in 1;
    opacity: 0;

    @media (--md-min) {
      display: block;
      opacity: 1;
    }
  }
}

@keyframes backdropFadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.2;
  }
  100% {
    opacity: 1;
  }
}

.slide-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: $height-panel;
  transform: translate3d(0, calc(100% + $height-panel-header), 0);
  transition: cubic-bezier(0.4, 0, 0.2, 1) 0.4s;
  z-index: $zindex-slider-container;
  border-radius: var(--radius-m, $radius-m) var(--radius-m, $radius-m) 0 0;
  border: 1px solid var(--border-color-primary, border-color('primary'));
  background-color: var(--background-color-primary, background-color('primary'));
  color: var(--text-color-primary, text-color('primary'));
  box-sizing: border-box;

  &.slide-up {
    transform: translate3d(0, 0, 0);
  }

  @media (--md-max) {
    display: none;
  }
}

.slide-container-inner {
  width: 80%;
  margin: 0 auto;
  max-width: pxToRem(840);
  height: $height-panel;

  orama-chat {
    height: 100%;
  }
}

.slide-container-header {
  height: calc(100vh - $height-panel);
  width: 100%;
  position: absolute;
  top: - calc(100vh - $height-panel);
  display: flex;
  justify-content: flex-end;
  padding: 0 var(--spacing-3xl, $spacing-3xl);
  box-sizing: border-box;
}

.close-button {
  cursor: pointer;
  border: 0;
  background-color: transparent;
  color: var(--text-color-primary, text-color('primary'));
  animation: showIn 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0.1s forwards;
}
